module.exports = __webpack_public_path__ + "img/05.6ca526a8.png";